module.exports = __webpack_public_path__ + "assets/img/service-97cae59f.png";